import { Button, Modal } from '@paysense-india-services/elevate-web'

import CardComponent from '@/components/CardComponent'

import styles from './index.module.scss'

const ReviewPaymentBottomSheet = ({ data, onClose, onPay, show }) => {
  if (!data) {
    return null
  }

  const items = data?.components?.items || []
  const totalItem = items.find(item => item.title?.toLowerCase() === 'total')
  const otherItems = items.filter(item => item.title?.toLowerCase() !== 'total')

  return (
    <Modal
      className='ew-bg-secondary ew-p-16'
      onCrossClick={onClose}
      onOverlayClick={onClose}
      show={show}
      showCross={true}>
      <div>
        <div className='ew-typography-large ew-fw-bold ew-color-primary'>{data?.title}</div>
        {data?.subtitle ? (
          <div className='ew-typography-small ew-color-secondary ew-fw-regular ew-mt-4 ew-mb-8'>
            {data.subtitle}
          </div>
        ) : null}
      </div>
      <CardComponent className='ew-mt-8'>
        <div className='ew-d-flex ew-flex-column ew-gap-16'>
          {otherItems.map((item, index) => (
            <div key={item.title || `item-${index}`}>
              <div className='ew-d-flex ew-justify-content-between ew-align-items-start'>
                <div className='ew-d-flex ew-flex-column'>
                  <div className='ew-typography-small ew-fw-regular'>{item.title}</div>
                  {item.description ? (
                    <div className='ew-typography-tiny ew-color-inactive ew-fw-regular ew-mt-4'>
                      {item.description}
                    </div>
                  ) : null}
                </div>
                <div className='ew-typography-small'>{item.subtitle}</div>
              </div>
            </div>
          ))}
        </div>

        {totalItem ? (
          <>
            <div className={`${styles.totalDivider} ew-my-12 ew-border`} />
            <div className='ew-d-flex ew-justify-content-between ew-align-items-center'>
              <div className='ew-typography-small'>{totalItem.title}</div>
              <div className='ew-typography-small'>{totalItem.subtitle}</div>
            </div>
          </>
        ) : null}
      </CardComponent>
      {data?.actions ? (
        <Button className='ew-mt-16' fullWidth onClick={onPay} size='medium' variant='brand'>
          {data.actions.text || 'Pay'}
        </Button>
      ) : null}
    </Modal>
  )
}

export default ReviewPaymentBottomSheet
